import { IColumn, ICommandBarItemProps, Icon, Stack, TooltipHost, mergeStyleSets } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import IconHelper from "../../../utils/helpers/iconHelper";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { PanelAddTipoEquipo } from "./PanelAddTipoEquipo";
import { useTableTipoEquipo } from "../../../hooks/TablasHooks/useTableTipoEquipo";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { PanelActualizarTipoEquipo } from "./PanelActualizarTipoEquipo";
import { useState } from "react";
import { IActualizarTipoEquipo, IDataTableTipoEquipo } from "../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});


export const ConfigTipoEquipos = () => {
  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [
    isOpenPanelEditar,
    { setTrue: openPanelEditar, setFalse: onDismissPanelEditar },
  ] = useBoolean(false);

  const [modelActualizarEquipoTipo, setModelActualizarEquipoTipo] =
    useState<IActualizarTipoEquipo>({
      TipoEquipoId: "",
      Nombre: ""
    });

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        onClickRefresh();
      },
    },
  ];

  const {
    loading,
    paginacion,
    dataItems,
    onClickRefresh,
    _onkeyUpSearch,
    searchBoxRefTable,
    onChangeSkip,
  } = useTableTipoEquipo();

  const column: IColumn[] = [
    {
      key: "tipoEquipo",
      name: "Tipo Equipo",
      fieldName: "nombre",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fechaCreado",
      name: "Fecha de Creación",
      fieldName: "fechaCreada",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item) => (
        <>

          <TooltipHost content={"Editar"}>
            <Icon
              iconName="edit"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                setModelActualizarEquipoTipo({
                  ...modelActualizarEquipoTipo,
                  TipoEquipoId: item.tipoEquipoId,
                  Nombre: item.nombre
                });
                openPanelEditar();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];
  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Nombre"
            componentRef={searchBoxRefTable}
            Titulo="Tipo de Equipos"
            SubTitulo="Gestión de Tipo de Equipo"
            onKeyUp={_onkeyUpSearch}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_items}
          data={dataItems}
          column={column}
          isLoading={loading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <PanelAddTipoEquipo
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        onRefreshTable={onClickRefresh}
      />
      <PanelActualizarTipoEquipo
        isOpen={isOpenPanelEditar}
        onDismiss={onDismissPanelEditar}
        modelActualizarEquipoTipo={modelActualizarEquipoTipo}
        onRefreshTable={onClickRefresh}
      />
    </>
  );
};
